import React from 'react';
import { useDispatch } from 'react-redux'

import Aux from '../../hoc/Aux';
import { useForm } from 'react-hook-form'
import * as actions from '../../store/actions/index';
import Navigation from './Navigation';
import { useTranslation } from 'react-i18next';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';
import useCustomTranslation from '../../hooks/useCustomTranslation';

const eliminateAccount = (props) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { register, setError, errors, handleSubmit } = useForm();
  const ht = useCustomHtmlTranslation();
  const ct = useCustomTranslation();

  const onSubmit = data => {
    dispatch( actions.deleteAccount(data) ).then( (res) => {
      res && res.errors && errorHandling(res.errors)
    });
  } ;


  const errorHandling = (e) => {

    if ( Array.isArray(e['old_password']) ) {
      setError("oldPassword", {
              type: "manual",
              message: t('form.changePassword.errors.oldPassword.' + e['old_password'][0]['error'] )
            });
    }
  }

  const intialValues = {
    oldPassword: '',
    password: '',
    passwordConfirmation: '',
  };

  const fieldClassName = (error) => {
    return (error)? "form-control is-invalid" : "form-control"
  }

  return (
    <Aux>
    	<div className="main-container">
    		<div className="container">
    			<div className="row justify-content-center mt-5">
    				<div className="col-lg-10 col-xl-9">
    					<div className="page-header">
    						<h1 className="pb-2">{ ct('delete_account.title') }</h1>
                <span className="lead">
                  { ht('account.delete_account') }
                </span>
    					</div>
    				</div>
    			</div>
    			<div className="row justify-content-center mt-3">
    				<div className="col-lg-3 mb-3">
              <Navigation activeItem="eliminate_account" />
    				</div>
    				<div className="col-lg-7 col-xl-6">
    					<div className="card">
    						<div className="card-body">
    							<div className="tab-content">
    								<div className="tab-pane fade show active" role="tabpanel" id="userdata">
    									<h4>{ ct('delete_account.subtitle') }</h4>
    									<form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-group row align-items-center">
                          <label className="col-3">{ ct('delete_account.form.current_password') }</label>
                          <div className="col">
                            <input
                              type="password"
                              className={fieldClassName(errors.oldPassword)}
                              name="oldPassword"
                              defaultValue={intialValues.oldPassword}
                              ref={register({ required: true})} />
                               { (errors.oldPassword)?
                                   <div className="invalid-feedback">
                                      {errors.oldPassword.message}
                                    </div> : null
                                }
                          </div>
                        </div>
    										<div className="row justify-content-end">
    											<button type="submit" className="btn btn-primary btn-project">{ ct('delete_account.form.button.submit') }</button>
    										</div>
    									</form>
    								</div>
    							</div>
    						</div>
    					</div>
    				</div>
    			</div>
    		</div>
    	</div>
    </Aux>
  );


};

export default eliminateAccount;



// WEBPACK FOOTER //
// ./src/components/User/EliminateAccount.js